/* eslint-disable prettier/prettier */
import { Box, Typography } from "@mui/material";
import { clsx } from "clsx";
import useStyles from "./Styles";

interface CountProps {
  count: number;
}
const Count: React.FC<CountProps> = ({ count }) => {
  const { classes } = useStyles();

  return (
    <>
      <Box className={classes.countBox}>
        <Typography className={classes.countBoxTypo}>{count} Labels</Typography>
      </Box>
      <Box className={classes.infoBox}>
        <Box className={classes.infoText}>
          <Box className={clsx(classes.square, classes.backgroundPersonal)} />
          <Typography className={classes.title}>My Labels</Typography>
        </Box>
        <Box className={classes.infoText}>
          <Box className={clsx(classes.square, classes.backgroundGeneric)} />
          <Typography className={classes.title}>Generic Labels</Typography>
        </Box>
      </Box>
    </>
  );
};

export default Count;
